import { FC } from 'react';
import dunbarLogo from 'src/assets/images/logos/logo-with-text_dark-148.png';
import { ResolvedBranding } from './branding';

interface BrandLogoProps {
  branding: ResolvedBranding;
  className?: string;
  /** Use the dark-surface variant when the logo sits on a dark background. */
  onDark?: boolean;
}

/**
 * Circle logo with the Dunbar logo as fallback. Unbranded circles render the
 * exact same <img> the header always rendered.
 */
export const BrandLogo: FC<BrandLogoProps> = ({
  branding,
  className,
  onDark = false,
}) => {
  const brandedSrc = onDark
    ? (branding.logoDarkUrl ?? branding.logoUrl)
    : branding.logoUrl;
  if (branding.isBranded && brandedSrc) {
    return (
      <img className={className} src={brandedSrc} alt={branding.displayName} />
    );
  }
  return <img className={className} src={dunbarLogo} alt="logo-with-text" />;
};
